import { Room } from 'livekit-client'

import { clientLogError } from '@/src/lib/clientLog'

export const setTypeOfMeet = async (room: Room, meet_id: number, sub_type_id: number) => {
  try {
    const meet_room_id = await room?.getSid()

    if (meet_room_id) {
      await fetch(`${process.env.NEXT_PUBLIC_PLATFORM_ENDPOINT}/set_type_meet`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          meet_id,
          meet_room_id,
          sub_type_id: sub_type_id,
        }),
      })
    }
  } catch (e) {
    const error: Error = e
    const errorMessage = `Error with setting type of meet (meet_id: ${meet_id}; sub_type_id: ${sub_type_id})`

    console.error(`${errorMessage}: ${error}`)

    clientLogError(`${errorMessage}: ${JSON.stringify(error.message)}`)
  }
}
